<div class="scan-option">
  <div class="scan-line-1">
    <span class="scan-name">
      {{ history.historyId }}
    </span>
    <span class="scan-state" [class.done]="history.status === 'completed'">
      {{ history.status }}
    </span>
    <span class="scan-separator">|</span>
    <span class="scan-dates">
      {{ history.creationDate | date: 'short' }}
    </span>
  </div>
  <div class="scan-line-2">
    <span>UUID: {{ history.uuid }}</span>
  </div>
</div>
